import React from "react";
import { Modal, Button } from "antd";
import CircularProgress from "@mui/material/CircularProgress";

const ConfirmationModal = ({
  open,
  onCancel,
  onConfirm,
  title,
  description,
  details = [],
  icon = null,
  confirmText = "YES",
  cancelText = "NO",
  confirmLoading = false,
  width = 500,
  confirmButtonClassName = "",
  cancelButtonClassName = "",
}) => {
  return (
    <Modal
      open={open}
      centered
      closable={false}
      width={width}
      onCancel={onCancel}
      styles={{
        mask: {
          backdropFilter: "blur(2px)",
        },
      }}
      footer={
        <div className="w-full flex gap-3 justify-center mt-6">
          <Button
            className={
              cancelButtonClassName ||
              "w-[11rem] h-[3rem] border-brand-border text-fg-muted rounded-lg font-[600]"
            }
            onClick={onCancel}
          >
            {cancelText}
          </Button>

          <Button
            className={
              confirmButtonClassName ||
              "w-[11rem] h-[3rem] bg-primary text-fg-inverse rounded-lg font-[600]"
            }
            onClick={onConfirm}
            disabled={confirmLoading}
          >
            {confirmLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              confirmText
            )}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 py-2">
        {icon && <div className="flex justify-center text-[42px]">{icon}</div>}

        {title && (
          <div className="text-center text-fg text-[22px] font-[600]">
            {title}
          </div>
        )}

        {description && (
          <div className="text-center text-fg-muted text-[15px] leading-6">
            {description}
          </div>
        )}

        {details.length > 0 && (
          <div className="bg-surface-page border border-brand-border-muted rounded-xl p-4">
            <div className="flex flex-col gap-2">
              {details.map((item, index) => (
                <div
                  key={index}
                  className="text-fg-secondary text-[14px] font-[500]"
                >
                  ✓ {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
